import BookItem from "../common/bookItem";
import { mouseEvent } from "../common/mouse_event";
import Visibility from "../common/visibility";
export default class OpenAfile extends BookItem {
    /**
     *
     * @type {Visibility}
     * @memberof JumpPage
     */
    visibilityComponent = null;
    constructor(el, target) {
        super(el, target);
        this.connectNumber = this.el.connectNumber;
        this.fileName = el.fileName;
        this.targetFrame = el.targetFrame - 1;
        this.startFrame = (el.startFrame - 1) == -1 ? this.targetFrame : (el.startFrame - 1);
        //測試用
        this.isTrigger = true;
        // this.targetFrame = -1;
    }

    init() {
        mouseEvent.add_mouse_event(this);
        this.target.gotoAndStop(0);

        this.target.visible = false;
        
        this.visibilityComponent = new Visibility(this.target, this, this.itemControl);
    }

    start() {
        this.visibilityComponent.setVisibleByGroup();
    }
    
    trigger() {
        window.aFileControl.open(this.fileName, this.targetFrame, this.startFrame);
    }
}